__turbopack_context__.v({
  "applicationHeader": "ggky2a_applicationHeader",
  "collapseButton": "ggky2a_collapseButton",
  "compactCollapseButton": "ggky2a_compactCollapseButton",
  "compactNavigation": "ggky2a_compactNavigation",
  "compactNavigationFooter": "ggky2a_compactNavigationFooter",
  "compactNavigationLinkIcon": "ggky2a_compactNavigationLinkIcon",
  "content": "ggky2a_content",
  "contentWrapper": "ggky2a_contentWrapper",
  "contextPanel": "ggky2a_contextPanel",
  "contextPanelHost": "ggky2a_contextPanelHost",
  "frame": "ggky2a_frame",
  "frameBody": "ggky2a_frameBody",
  "frameMain": "ggky2a_frameMain",
  "headerContent": "ggky2a_headerContent",
  "loadingOverlay": "ggky2a_loadingOverlay",
  "mobileActions": "ggky2a_mobileActions",
  "mobileActionsHost": "ggky2a_mobileActionsHost",
  "mobileOnly": "ggky2a_mobileOnly",
  "navigationFooter": "ggky2a_navigationFooter",
  "navigationRow": "ggky2a_navigationRow",
  "navigationRowLabel": "ggky2a_navigationRowLabel",
  "navigationSection": "ggky2a_navigationSection",
  "navigationTile": "ggky2a_navigationTile",
  "primaryNavigation": "ggky2a_primaryNavigation",
  "railMenu": "ggky2a_railMenu",
  "railMenuItem": "ggky2a_railMenuItem",
  "railMenuLabel": "ggky2a_railMenuLabel",
  "railRow": "ggky2a_railRow",
  "scrollableNavigationSection": "ggky2a_scrollableNavigationSection",
  "shortcutKey": "ggky2a_shortcutKey",
  "shortcutLabel": "ggky2a_shortcutLabel",
});
